import { CrosswordGrid, CrosswordProvider, ThemeProvider } from "@bekodo/react-crossword"
import { createRef, useEffect, useState } from "react"
import { CarregarCustomMot, CarregarMotAvui, EndGame, InitiateSingleClue, LoadFromCache, ReiniciarMotsEncreuats, VeureMotsEncreuatsAnteriors, getCrosswordFromLocalStorage } from "./Actions"
import { crossword_style } from "./assets/Theme"
import CluesDesktop from "./components/clues/CluesDesktop"
import CluesMobile from "./components/clues/CluesMobile"
import CustomVirtualKeyboard from "./components/custom-virtual-keyboard/CustomVirtualKeyboard"
import HelpButton from "./components/help/HelpButton"
import EndGameModal from "./components/modals/EndGameModal"
import MotsHistory from "./components/mots-history/MotsHistory"
import Options from "./components/options/Options"
import Timer from "./components/timer/Timer"
import { api_urls, date_to_nice_date, get_data_from_url, get_day_today, json_to_upper_case } from "./utils"

// eslint-disable-next-line
import HelpPaper from "./components/help/HelpPaper"

const CrosswordGame = () => {
	const crossword_game_ref = createRef()

	const [crosswordData, setCrosswordData] = useState({ content: json_to_upper_case({ across: {}, down: {} }), date: "" })
	const [crosswordNumber, setCrosswordNumber] = useState(0)
	const [allCrosswords, setAllCrosswords] = useState([])
	const [end_game_modal_open, set_end_game_modal_open] = useState(false);
	const [forced_timer_stop, set_forced_timer_stop] = useState(false);
	const [motCorrect, setMotCorrect] = useState(false);
	const [first_correct_states, set_first_correct_states] = useState(false)
	const [last_correct_states, set_last_correct_states] = useState(false)
	const [cellChanged, setCellChanged] = useState(false);
	const [fillFromStorage, setFillFromStorage] = useState(false)
	const [once, setOnce] = useState(false)
	const [helpOpen, setHelpOpen] = useState(false)
	const [selectedDevice, setSelectedDevice] = useState(Boolean(window.screen.width > 768))
	const [isCustom, setIsCustom] = useState(false)

	useEffect(() => {
		const url = new URL(window.location.href);
		if (url.search.includes('especial=')) {
			let customURL = url.search.split('especial=')[1]
			customURL = customURL.split('&')[0]
			if (customURL) {
				setIsCustom(true)
				CarregarCustomMot(customURL, setCrosswordData, crossword_game_ref, setOnce)
			} else {
				CarregarMotAvui(setCrosswordData, crossword_game_ref, setOnce)
			}
		} else {
			CarregarMotAvui(setCrosswordData, crossword_game_ref, setOnce)
		}

		get_data_from_url(api_urls.all_crosswords_url).then((data) => {
			setAllCrosswords(data)
		})
	}, [])

	useEffect(() => {
		// Find the crossword number by date
		allCrosswords && allCrosswords.forEach((crossword, index) => {
			if (date_to_nice_date(new Date(crossword.date.$date), 'dotted') === crosswordData.date) {
				setCrosswordNumber(index)
			}
		})
	}, [crosswordData, allCrosswords])


	useEffect(() => {
		InitiateSingleClue()
		LoadFromCache(crosswordData, crossword_game_ref)
		set_forced_timer_stop(false)
	}, [once])

	useEffect(() => {
		setFillFromStorage(true)
	}, [crosswordData.content])

	useEffect(() => {
		if (fillFromStorage === true && once === false && (Object.keys(crosswordData.content.across).length > 0 || Object.keys(crosswordData.content.down).length > 0)) {
			ReiniciarMotsEncreuats(crossword_game_ref)
			setOnce(true)
		}
	}, [fillFromStorage, crosswordData, crossword_game_ref, once])

	const onCellChange = (row, col, guess) => {
		let grid = document.getElementsByClassName('crossword grid')[0]
		grid.querySelectorAll('.clue-cell').forEach((cell) => {
			if (cell) {
				let text = cell.querySelector('[text-anchor="middle"]')
				if (text.innerHTML === "" && text.classList) {
					text.classList.remove('correct_cell')
					text.classList.remove('crossed_cell')
				}
			}
		})

		let guesses_storage = JSON.parse(localStorage.getItem('guesses_storage'))
		if (getCrosswordFromLocalStorage(crosswordData.date) == null) {
			guesses_storage.push({ date: crosswordData.date, content: {} })
			localStorage.setItem('guesses_storage', JSON.stringify(guesses_storage))
		}
		guesses_storage.forEach((items) => {
			if (items.date === crosswordData.date) {
				items.content[row + "_" + col] = guess
			}
		})
		localStorage.setItem('guesses_storage', JSON.stringify(guesses_storage))
		if (guess !== "") {
			setCellChanged(true)
		}
	}

	const onCrosswordComplete = (correct) => {
		if (cellChanged) {
			if (last_correct_states !== correct || !first_correct_states) {
				set_first_correct_states(true)
				set_last_correct_states(correct)
				if (correct) {
					set_forced_timer_stop(true)
				}

				setMotCorrect(correct)
				EndGame(set_end_game_modal_open)
			}
		}
	}

	function handleEndGameModal() {
		set_end_game_modal_open(false)
		setCellChanged(false)
		let crossword_input = document.querySelector('[aria-label="crossword-input"]')
		if (crossword_input) {
			crossword_input.disabled = false
		}
	}

	return <div className="container flex flex-col relative pb-20">
		<div className="flex flex-wrap">
			<div className="w-full mx-auto">
				<ThemeProvider theme={crossword_style}>
					{!isCustom && <><div className="w-full uppercase font-bold section-title pb-4 md:pb-6">
						Jocs
					</div>
						<div className="flex mb-2 md:mb-12 pb-3 md:pb-0 border-b-solid border-b-[1px] md:border-none border-b-gray_light space-x-2 md:space-x-6 space-b place-content-between md:place-content-start">
							<a href="/paraulogic/" className="uppercase font-bold category-title hover:text-orange_text">
								Paraulògic
							</a>
							<div className="uppercase font-bold category-title text-orange_text">
								Minimots
							</div>
							<a href="/motli/" className="uppercase font-bold category-title hover:text-orange_text">
								Mot-li!
							</a>
							<a href="https://www.vilaweb.cat/que-se-jo/" className="uppercase font-bold category-title hover:text-orange_text">
								Què sé jo?
							</a>
						</div>
						<div className="p-0 flex md:hidden place-content-end mb-6">
							<div className="mr-3 p-0 flex h-[30px] w-[30px] cursor-pointer items-center justify-center rounded-full border border-solid border-gray_light">
								<Options setCrosswordData={setCrosswordData} setOnce={setOnce} crosswordData={crosswordData} ref={crossword_game_ref} />
							</div>
							<div className="flex h-[30px] w-[30px] p-0 items-center cursor-pointer justify-center rounded-full border border-solid border-gray_light">
								<HelpButton helpOpen={helpOpen} device={'mobile'} setHelpOpen={setHelpOpen} setSelectedDevice={setSelectedDevice} />
							</div>
						</div>
					</>}
					{isCustom && <div className="w-full uppercase font-bold section-title pb-4 pb- md:pb-6 text-orange_text">
						Minimots
					</div>}
					<div className="flex space-x-[60px]">
						<div className="hidden md:flex col-5 justify-left items-end w-full mots-config-bar mb-10 mx-0 pb-2">
							<div className="text-[18px] md:text-[15px] lg:text-[18px] font-[400]">
								Pau Vidal
							</div>
						</div>
						<div className="grid-flow-col gap-4 hidden md:grid w-full mots-config-bar mb-10 mx-0 pb-2 justify-left items-end">
							<div className="col-start-1 col-end-1 text-[18px] md:text-[15px] lg:text-[18px] p-0 font-[400]">
								<div className="flex space-x-1">
									<div>Núm. {crosswordNumber}</div>
									<div>-</div>
									<div>{crosswordData.date}</div>
								</div>
							</div>
							{!isCustom &&
								<div className="col-start-2 col-end-2 justify-self-end text-[18px] md:text-[15px] lg:text-[18px] p-0 font-[400] text-orange_text cursor-pointer" onClick={() => { VeureMotsEncreuatsAnteriors(crosswordData.date === get_day_today()); }}>
									{crosswordData.date === get_day_today(crosswordData.date) || !crosswordData.date ? <div
										onClick={() => { VeureMotsEncreuatsAnteriors(setCrosswordData, crossword_game_ref, setOnce) }}>Minimots anteriors
									</div> :
										<div
											onClick={() => { CarregarMotAvui(setCrosswordData, crossword_game_ref, setOnce) }}>Minimot d'avui
										</div>
									}
								</div>
							}
							<div className="col-start-3 col-end-3 p-0 pl-[5px] flex justify-self-end">
								<div className="mr-3 p-0 px-0 flex h-[30px] !w-[30px] cursor-pointer items-center justify-center rounded-full border border-solid border-gray_light">
									<Options setCrosswordData={setCrosswordData} setOnce={setOnce} crosswordData={crosswordData} ref={crossword_game_ref} />
								</div>
								<HelpButton helpOpen={helpOpen} device={'desktop'} setHelpOpen={setHelpOpen} setSelectedDevice={setSelectedDevice} />
								<div className="relative desktop-help-modal">
									<HelpPaper
										device={'desktop'}
										selectedDevice={selectedDevice}
										open={helpOpen}
										setHelpOpen={setHelpOpen}
									/>
								</div>
							</div>
						</div>
					</div>
					<div id="timer-desktop" className="hidden md:flex mb-5">
						<Timer spec_id={"desktop"} modalOpen={end_game_modal_open} forced_timer_stop={forced_timer_stop} />
					</div>
					<div className="flex md:hidden mb-1 w-full justify-between justify-left items-end">
						<div className="text-[15px] p-0">
							Pau Vidal
						</div>
						<div className="text-[15px] p-0 space-x-1 flex">
							<div>Núm. {crosswordNumber}</div>
							<div>-</div>
							<div>{crosswordData.date}</div>
						</div>
						<div className="p-0 hidden md:flex">
							<div className="mr-3 p-0 flex h-[30px] w-[30px] cursor-pointer items-center justify-center rounded-full border border-solid border-gray_light">
								<Options setCrosswordData={setCrosswordData} setOnce={setOnce} crosswordData={crosswordData} ref={crossword_game_ref} />
							</div>
							<div className="flex h-[30px] w-[30px] p-0 items-center cursor-pointer justify-center rounded-full border border-solid border-gray_light">
								<HelpButton helpOpen={helpOpen} device={'mobile'} setHelpOpen={setHelpOpen} setSelectedDevice={setSelectedDevice} />
							</div>
						</div>
						<div id="timer-mobile"><Timer spec_id={"mobile"} modalOpen={end_game_modal_open} forced_timer_stop={forced_timer_stop} /></div>
					</div>
					<div id="vilaweb-minimots-game">
						<CrosswordProvider
							key={'crossword'}
							data={crosswordData.content}
							onCrosswordComplete={onCrosswordComplete}
							ref={crossword_game_ref}
							onCellChange={onCellChange}
						>
							<div className="md:flex align-center row w-full crossword-container">
								<div className="w-full md:col-5 px-0">
									<div className="clues-display hidden md:flex mb-5 clue-individual-desktop">
										<CluesMobile
											label_across="HORITZONTALS"
											label_down="VERTICALS"
											ref={crossword_game_ref}
											id="mobile_clue_desktop"
										/>
									</div>
									<div className="relative mobile-help-modal">
										<HelpPaper
											device={'mobile'}
											selectedDevice={selectedDevice}
											open={helpOpen}
											setHelpOpen={setHelpOpen}
										/>
									</div>
									<CrosswordGrid />
								</div>
								<div className="w-full md:col-7 p-0 md:pl-[60px] gap-10 background-orange">
									<CluesDesktop
										label_across="HORITZONTALS"
										label_down="VERTICALS"
										ref={crossword_game_ref}
									/>
									<div className="clues-display block md:hidden mt-5 full-w-container background-orange">
										<CluesMobile
											label_across="HORITZONTALS"
											label_down="VERTICALS"
											ref={crossword_game_ref}
											id="mobile_clue_mobile"
										/>
									</div>
								</div>
							</div>
							<div className="w-full block md:hidden full-w-container">
								<CustomVirtualKeyboard ref={crossword_game_ref} />
							</div>
						</CrosswordProvider>
					</div>
					<div id="vilaweb-minimots-game-empty" className="hidden">
						Avui no hi ha cap Minimot.
					</div>
				</ThemeProvider>
			</div>
			<div id="vilaweb-minimots-history" className="hidden w-full mx-auto">
				<MotsHistory ref={crossword_game_ref} crosswordData={crosswordData} setCrosswordData={setCrosswordData} setOnce={setOnce} allCrosswords={allCrosswords} />
			</div>
			<EndGameModal
				handleEndGameModal={handleEndGameModal}
				showModal={end_game_modal_open}
				motCorrect={motCorrect}
			/>
		</div>
	</div >
}

export default CrosswordGame
